import classnames from "classnames/bind";
import { memo, useState } from "react";
import { Handle } from "reactflow";

import { BoxTitles } from "@boxes/BoxTitles";
import { ForEach, If } from "@components/control-statements";

import { BoxTypes } from "@boxes/BoxTypes";
import { BoxValidations } from "@boxes/BoxValidations";
import style from "@styles/pages/flow/boxes/Box.module.scss";
const css = classnames.bind(style);

export default memo(({ data, selected, isConnectable }) => {
  const [collapse, setCollapse] = useState(false);

  return (
    <div className={css({ selected: selected })}>
      <div
        className={css({
          inner: true,
          group: true,
          needsSetup: !BoxValidations.validate(BoxTypes.ConditionalGroup, data),
        })}
      >
        <div className={style.header} onClick={() => setCollapse(!collapse)}>
          <div className={style.icon}>
            <i className="far fa-layer-group" />
          </div>
          <div className="d-flex align-center justify-between flex-1">
            <div className="d-flex flex-column">
              <p className={style.title}>{BoxTitles.ConditionalGroup}</p>
              <If cond={data?.conditionals?.length}>
                <span className={style.subtitle}>
                  {data?.conditionals?.length} filtros aplicados
                </span>
              </If>
            </div>
            <If cond={data?.conditionals?.length}>
              <div className={css({ chevron: true, rotate: collapse })}>
                <i className="fas fa-chevron-down" />
              </div>
            </If>
          </div>
        </div>

        {collapse && (
          <div className={style.collapse}>
            <ul>
              <ForEach
                items={data.conditionals || []}
                render={(conditional) => {
                  return (
                    <li>
                      <p>{conditional.label}</p>
                      <div
                        className={style.setup}
                        onClick={(e) => {
                          e.stopPropagation();
                          e.preventDefault();
                          e.target.parentNode.dispatchEvent(
                            new CustomEvent("click", {
                              bubbles: true,
                              detail: {
                                setup: true,
                                conditionalId: conditional.id,
                              },
                            })
                          );
                        }}
                      >
                        <i className="far fa-gear" />
                      </div>
                    </li>
                  );
                }}
              />
            </ul>
          </div>
        )}
      </div>

      <Handle
        type="target"
        position="left"
        className={style.handleTarget}
        isConnectable={isConnectable}
      />
      <Handle
        type="source"
        id="has"
        position="right"
        className={style.handleYes}
        isConnectable={isConnectable}
      />
      <Handle
        type="source"
        id="hasNot"
        position="right"
        className={style.handleNo}
        isConnectable={isConnectable}
      />
    </div>
  );
});
